import type { FC } from "react";
import { useMutation } from "@tanstack/react-query";
import { Translate, useTranslation } from "@privacy/translations";
import { makeOwnCopyMutationOptions } from "../api/registrations";
import type { RegistrationById } from "../api/registrations.types";
import { ConfirmDeleteDialog } from "../shared/ConfirmDeleteDialog";
import { Strong } from "../shared/Strong";

export const MakeOwnCopyDialog: FC<{
  registration: RegistrationById;
  onClose: () => void;
  onCopied: (copyId: string) => void;
}> = ({ registration, onClose, onCopied }) => {
  const { t } = useTranslation();
  const makeOwnCopyMutation = useMutation(makeOwnCopyMutationOptions());

  return (
    <ConfirmDeleteDialog
      isOpen
      headerText={t("RegistrationDrawer.MakeOwnCopy.ConfirmHeader", { name: registration.name })}
      message={
        <Translate
          translationKey="RegistrationDrawer.MakeOwnCopy.ConfirmMessage"
          values={{ customer: <Strong>{registration.organisationEditability?.managedBy?.name ?? ""}</Strong> }}
        />
      }
      confirmButtonLabel={t("RegistrationDrawer.MakeOwnCopy.Label")}
      onClose={onClose}
      onDelete={() => makeOwnCopyMutation.mutateAsync(registration.id).then(copy => onCopied(copy.id))}
    />
  );
};
